import { Component } from '@angular/core';
import { Autor } from '../../model/Autor';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { AutorxsService } from '../../services/autorxs.service';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-autorxs-particulares',
  imports: [CommonModule, MatCardModule, RouterModule, MatProgressSpinnerModule],
  templateUrl: './autorxs-particulares.component.html',
  styleUrl: './autorxs-particulares.component.scss'
})
export class AutorxsParticularesComponent {

  constructor(private service: AutorxsService, private route: ActivatedRoute) { }

  public autor: Autor | null = null;
  public showSpinner: boolean = true;

  ngOnInit() {

    this.service.getAutorById(Number(this.route.snapshot.paramMap.get('id'))).subscribe(autor => {
      this.autor = autor;
      this.showSpinner = false;
    });

  }
}
